import { useState, useEffect } from 'react';
import { getContactSettings } from '../services/adminService';

// Module-level cache — shared across all component instances
let _cachedSettings = null;
let _cacheTimestamp = 0;
let _pendingPromise = null;
const CACHE_TTL = 10 * 60 * 1000; // 10 minutes

const fetchOnce = async () => {
  // Return cached if fresh
  if (_cachedSettings && Date.now() - _cacheTimestamp < CACHE_TTL) {
    return _cachedSettings;
  }
  // Deduplicate concurrent requests
  if (_pendingPromise) return _pendingPromise;

  _pendingPromise = getContactSettings()
    .then((data) => {
      _cachedSettings = data;
      _cacheTimestamp = Date.now();
      _pendingPromise = null;
      return data;
    })
    .catch(() => {
      _pendingPromise = null;
      return _cachedSettings; // return stale on error
    });

  return _pendingPromise;
};

// Bust the module cache so all components pick up fresh data on next render
export const invalidateContactSettingsCache = () => {
  _cachedSettings = null;
  _cacheTimestamp = 0;
  _pendingPromise = null;
};

const useContactSettings = () => {
  const [contactSettings, setContactSettings] = useState(_cachedSettings);
  const [loading, setLoading] = useState(!_cachedSettings);

  useEffect(() => {
    let cancelled = false;
    fetchOnce().then((data) => {
      if (!cancelled) {
        setContactSettings(data);
        setLoading(false);
      }
    });
    return () => { cancelled = true; };
  }, []);

  return { contactSettings, loading };
};

export default useContactSettings;
